import { Provider } from '@angular/core';
import {
  DECLARATIVE_FORMS_FIELD_BUILDER_TOKEN,
  DECLARATIVE_FORMS_VALIDATION_MESSAGE_BUILDER_TOKEN,
} from '@fmnts/declarative-forms';
import { provideCommonDeclarativeFormsFeatures } from '@fmnts/declarative-forms/common';
import { SharedDeclarativeValidationMessageBuilder } from '@formunauts/shared/declarative-forms/data-access';
import { DeclarativeSupporterFeedbackFormFieldBuilder } from './supporter-feedback-field-builder.service';

/**
 * Provides everything needed for the declarative supporter feedback form.
 */
export function provideDeclarativeSupporterFeedbackForm(): Provider {
  return [
    provideCommonDeclarativeFormsFeatures(),
    DeclarativeSupporterFeedbackFormFieldBuilder,
    {
      provide: DECLARATIVE_FORMS_FIELD_BUILDER_TOKEN,
      useExisting: DeclarativeSupporterFeedbackFormFieldBuilder,
    },
    {
      provide: DECLARATIVE_FORMS_VALIDATION_MESSAGE_BUILDER_TOKEN,
      useClass: SharedDeclarativeValidationMessageBuilder,
    },
  ];
}
